exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dropzones {\n  position: relative;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n      grid-template-columns: 1fr;\n  gap: 3rem;\n  padding: 3rem; }\n  #dropzones .dropzone {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    border: dashed 3px #0002;\n    border-radius: 3rem; }\n    #dropzones .dropzone i {\n      opacity: 0.2;\n      font-size: 10vw; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/file-drag-drop/file-drag-drop.component.scss
// module id = ../../../../../src/app/ui-shared/file-drag-drop/file-drag-drop.component.scss
// module chunks = main